import React from "react";
import {
  Box,
  TextField,
  Typography,
  InputAdornment,
  Grid,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import {
  CityIcon,
  CountryIcon,
  LocationIcon,
  PincodeIcon,
  StateIcon,
} from "../../../../assets/icons";
import { indianStates } from "../../../../Helpers/constants";

const AddressDetails = (props) => {
  const { formData, handleChange } = props;

  return (
    <>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          mt: 3,
          fontWeight: "bold",
          textAlign: "left",
          fontweight: 600,
          fontSize: "16px",
          leadingTrim: "Cap height",
          lineHeight: "100%",
          letterSpacing: "0px",
          color: "#393939",
        }}
      >
        Address Details
      </Typography>

      <Grid container rowSpacing={3} columnSpacing={5}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            placeholder="Enter address here"
            name="address"
            value={formData.address}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z0-9\s]*$/.test(value)) {
                handleChange(e);
              }
            }}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", " "
              ];
              if (
                !/^[a-zA-Z0-9]$/.test(e.key) &&
                !allowedKeys.includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const paste = e.clipboardData.getData("text");
              if (!/^[a-zA-Z0-9\s]+$/.test(paste)) {
                e.preventDefault();
              }
            }}
            inputProps={{
              maxLength: 100,
            }}
            sx={{
              boxSizing: "border-box",
              borderRadius: "10px",
              backgroundColor: "#fff",
              borderColor: "#C0C0C0",
              borderWidth: "5px",
              "& .MuiOutlinedInput-root": {
                height: "46px",
                borderColor: "#C0C0C0",
                backgroundColor: "none",
                "&:hover fieldset": {
                  borderColor: "#C0C0C0",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C0C0C0",
                },
              },
              "& .MuiFormHelperText-root": {
                color: "#FF6666",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationIcon />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "10px",
                height: 45,
                fontSize: "16px",
                fontWeight: "400",
              },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            type="text"
            placeholder="Enter pin code"
            name="pinCode"
            value={formData.pinCode}
            onKeyDown={(e) => {
              if ( !/[0-9]/.test(e.key) && !["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(e.key) ) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const paste = e.clipboardData.getData("text");
              if (!/^\d+$/.test(paste) || paste.length > 6) {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,6}$/.test(value)) {
                handleChange(e);
              }
            }}
            inputProps={{
              maxLength: 6,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PincodeIcon />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "10px",
                height: 45,
                fontSize: "16px",
                fontWeight: "400",
              },
            }}
            sx={{
              boxSizing: "border-box",
              borderRadius: "10px",
              backgroundColor: "#fff",
              borderColor: "#C0C0C0",
              borderWidth: "5px",
              "& .MuiOutlinedInput-root": {
                height: "46px",
                borderColor: "#C0C0C0",
                backgroundColor: "none",
                "&:hover fieldset": {
                  borderColor: "#C0C0C0",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C0C0C0",
                },
              },
              "& .MuiFormHelperText-root": {
                color: "#FF6666",
              },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Enter city name"
            name="city"
            value={formData.city}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z\s]*$/.test(value)) {
                handleChange(e);
              }
            }}
            onKeyDown={(e) => {
              const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", " "];
              if (!/^[a-zA-Z]$/.test(e.key) && !allowedKeys.includes(e.key)) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const paste = e.clipboardData.getData("text");
              if (!/^[a-zA-Z\s]+$/.test(paste)) {
                e.preventDefault();
              }
            }}
            inputProps={{
              maxLength: 50,
            }}
            sx={{
              boxSizing: "border-box",
              borderRadius: "10px",
              backgroundColor: "#fff",
              borderColor: "#C0C0C0",
              borderWidth: "5px",
              "& .MuiOutlinedInput-root": {
                height: "46px",
                borderColor: "#C0C0C0",
                backgroundColor: "none",
                "&:hover fieldset": {
                  borderColor: "#C0C0C0",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C0C0C0",
                },
              },
              "& .MuiFormHelperText-root": {
                color: "#FF6666",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CityIcon />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "10px",
                height: 45,
                fontSize: "16px",
                fontWeight: "400",
              },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <Select
              displayEmpty
              name="country"
              value={formData.country}
              onChange={handleChange}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <CountryIcon />
                      <Typography sx={{ ml: 1, color: "text.secondary" }}>
                        Select Country
                      </Typography>
                    </Box>
                  );
                }
                return selected;
              }}
              sx={{
                height: 46,
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C0C0C0",
                  borderWidth: "1px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C0C0C0",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C0C0C0",
                },
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  height: "46px",
                  paddingLeft: "12px",
                },
              }}
            >
              <MenuItem value="India">India</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <Select
              displayEmpty
              name="state"
              value={formData.state}
              onChange={handleChange}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <StateIcon />
                      <Typography sx={{ ml: 1, color: "text.secondary" }}>
                        Select State
                      </Typography>
                    </Box>
                  );
                }
                return selected;
              }}
              sx={{
                height: 46,
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C0C0C0",
                  borderWidth: "1px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C0C0C0",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C0C0C0",
                },
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  height: "46px",
                  paddingLeft: "12px",
                },
              }}
            >
              {indianStates.map((state) => (
                <MenuItem key={state} value={state}>
                  {state}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};

export default AddressDetails;
